export var LAYOUT = {
	// General settings
	drawerWidth: 350,
	headerHeight: 90,
	headerBorderHeight: 8,
	headerBorderColor: "#002e6b",

	// Login settings
	loginPanelWidth: '40%',
	loginPanelMinWidth: 350,

	overrideDrawerWidth: 240,
}